import { useMutation } from '@tanstack/react-query'
import { queryClient } from 'src'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

export interface PostFilePayload {
  id: string
  file: File
}
export function usePostFiles<IQuestionnairesResponse>(
  vesselId: string | undefined,
) {
  const fetchRequest = useFetch()

  return useMutation({
    mutationFn: (payloads: PostFilePayload[]) => {
      const postRequests = payloads.map((payload) => {
        const formData = new FormData()
        formData.append('file', payload.file)
        formData.append('id', payload.id)

        return fetchRequest(
          `${apiBase()}/vessels/${vesselId}/file`,
          undefined,
          undefined,
          'POST',
          formData,
        ) as IQuestionnairesResponse
      })
      return Promise.all(postRequests)
    },
    onSuccess: () => {
      if (!vesselId) return
      queryClient.invalidateQueries({
        queryKey: [`/vessels/${vesselId}/questionnaire`],
      })
    },
  })
}
